import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  EnlargeSwitch,
  LayoutsPreviewContainer,
  Limiter,
  PreviewWrapper,
  Switch,
} from "./styles";
import { Description, FlexContainer, Subtitle, Wrapper } from "../../../styles";
import { Modal } from "../1-Layout/styles";
import { Slider, Tabs } from "antd";
import Button, { Return } from "../../Button";
import SquareShape from "../../Shapes/Squares";
import VerticalRectangleShape from "../../Shapes/Vertical Rectangles";
import HorizontalRectangleShape from "../../Shapes/Horizontal Rectangles";
import DraggableSquare from "../../Shapes/Squares/DraggableSquare";
import DraggableVerticalRectangle from "../../Shapes/Vertical Rectangles/DraggableVerticalRectangle";
import DraggableHorizontalRectangle from "../../Shapes/Horizontal Rectangles/DraggableHorizontalRectangle";
import ComponentToPngConverter from "../Download";
import {
  convertPositionRatio,
  pickHorizontalRectangleDefaultPositions,
  pickHorizontalRectangleDefaultSizes,
  pickSquareDefaultPositions,
  pickSquareDefaultSizes,
  pickVerticalRectangleDefaultPositions,
  pickVerticalRectangleDefaultSizes,
} from "../../Shapes/shapes-utils";
import { useSelector } from "react-redux";

export default function Preview({
  texts,
  confirmedImage,
  layout,
  previousStep,
  logoSrc,
}) {
  const squareDefaultPositions = pickSquareDefaultPositions({
    shape: layout.layout,
    size: 320 * 1.2,
  });
  const verticalDefaultPositions = pickVerticalRectangleDefaultPositions({
    shape: layout.layout,
    size: 225 * 1.2,
  });
  const horizontalDefaultPositions = pickHorizontalRectangleDefaultPositions({
    shape: layout.layout,
    size: 512 * 1.2,
  });
  const [positions, setPositions] = useState([
    squareDefaultPositions.imagePosition,
    squareDefaultPositions.logoPosition,
    squareDefaultPositions.labelsPosition,
  ]);
  const [positionsVR, setPositionsVR] = useState([
    verticalDefaultPositions.imagePosition,
    verticalDefaultPositions.logoPosition,
    verticalDefaultPositions.labelsPosition,
  ]);
  const [positionsHR, setPositionsHR] = useState([
    horizontalDefaultPositions.imagePosition,
    horizontalDefaultPositions.logoPosition,
    horizontalDefaultPositions.labelsPosition,
  ]);
  const [x_axis, setX_axis] = useState({
    square: 50,
    vr: 50,
    hr: 50,
  });
  const [biggerPreview, setBiggerPreview] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const squareModalScale = 320 * 1.2;
  const VRModalScale = 271;
  const HRModalScale = 674.5;

  const changePreviewSize = () => {
    setBiggerPreview(!biggerPreview);
  };

  const changeAxis = ({ layout, value }) => {
    setX_axis((prev) => ({
      ...prev,
      [layout]: value,
    }));
  };

  const resetSquare = () => {
    setPositions([
      ...Object.values(
        pickSquareDefaultPositions({
          shape: layout.layout,
          size: squareModalScale,
        }),
      ),
    ]);

    changeAxis({ layout: "square", value: 50 });
  };

  const resetHR = () => {
    setPositionsHR([
      ...Object.values(
        pickHorizontalRectangleDefaultPositions({
          shape: layout.layout,
          size: HRModalScale,
        }),
      ),
    ]);

    changeAxis({ layout: "hr", value: 50 });
  };

  const resetVR = () => {
    setPositionsVR([
      ...Object.values(
        pickVerticalRectangleDefaultPositions({
          shape: layout.layout,
          size: VRModalScale,
        }),
      ),
    ]);

    changeAxis({ layout: "vr", value: 50 });
  };

  return (
    <Wrapper animated>
      <Return previousStep={previousStep} />
      <Subtitle marginTop="16px" marginBottom="0">
        <FormattedMessage id="ai_creator.preview" />
      </Subtitle>
      <Description marginBottom="0">
        <FormattedMessage id="ai_creator.preview.desc" />
        <span>
          <FormattedMessage id="ai_creator.preview.desc2" />
        </span>
      </Description>
      <Description>
        <FormattedMessage id="ai_creator.preview.desc3" />
      </Description>

      <FlexContainer marginBottom="32px" spaceBetween>
        <EnlargeSwitch>
          <span>
            <FormattedMessage id="ai_creator.preview.enlarge" />
          </span>
          <Switch
            defaultChecked={biggerPreview}
            checked={biggerPreview}
            onChange={changePreviewSize}
          />
        </EnlargeSwitch>

        <FlexContainer width="45%" gap="8px">
          <Button
            type={"button"}
            size={"modal"}
            theme={"secondary"}
            label={"ai_creator.preview.reposition_elements"}
            onClick={() => {
              setActiveKey("1");
              setOpen(true);
            }}
          />

          <ComponentToPngConverter
            logoSrc={logoSrc}
            texts={texts}
            confirmedImage={confirmedImage}
            layout={layout}
            positions={positions}
            squareModalScale={squareModalScale}
            convertPositionRatio={convertPositionRatio}
            positionsHR={positionsHR}
            positionsVR={positionsVR}
            horizontalRectangleScale={HRModalScale}
            verticalRectangleScale={VRModalScale}
            x_axis={x_axis}
          />
        </FlexContainer>
      </FlexContainer>

      <LayoutsPreviewContainer>
        <div>
          <PreviewWrapper
            onClick={() => {
              setActiveKey("1");
              setOpen(true);
            }}
          >
            <SquareShape
              logoSrc={logoSrc}
              callText={texts.callText}
              imageUrl={confirmedImage}
              primaryText={texts.primaryText}
              secondaryText={texts.secondaryText}
              shape={layout.layout}
              variantColor={layout.color}
              x_axis={x_axis.square}
              size={biggerPreview ? 560 : squareModalScale}
              positions={{
                imagePosition: convertPositionRatio({
                  currentSize: biggerPreview ? 560 : squareModalScale,
                  draggableSize: squareModalScale,
                  positions: positions[0],
                }),
                logoPosition: convertPositionRatio({
                  currentSize: biggerPreview ? 560 : squareModalScale,
                  draggableSize: squareModalScale,
                  positions: positions[1],
                }),
                labelsPosition: convertPositionRatio({
                  currentSize: biggerPreview ? 560 : squareModalScale,
                  draggableSize: squareModalScale,
                  positions: positions[2],
                }),
              }}
            />
          </PreviewWrapper>
          <p>1080x1350</p>
        </div>

        <div>
          <PreviewWrapper
            onClick={() => {
              setActiveKey("3");
              setOpen(true);
            }}
          >
            <VerticalRectangleShape
              logoSrc={logoSrc}
              callText={texts.callText}
              imageUrl={confirmedImage}
              primaryText={texts.primaryText}
              secondaryText={texts.secondaryText}
              shape={layout.layout}
              variantColor={layout.color}
              x_axis={x_axis.vr}
              size={biggerPreview ? 394 : VRModalScale}
              positions={{
                imagePosition: convertPositionRatio({
                  currentSize: biggerPreview ? 394 : VRModalScale,
                  draggableSize: VRModalScale,
                  positions: positionsVR[0],
                }),
                logoPosition: convertPositionRatio({
                  currentSize: biggerPreview ? 394 : VRModalScale,
                  draggableSize: VRModalScale,
                  positions: positionsVR[1],
                }),
                labelsPosition: convertPositionRatio({
                  currentSize: biggerPreview ? 394 : VRModalScale,
                  draggableSize: VRModalScale,
                  positions: positionsVR[2],
                }),
              }}
            />
          </PreviewWrapper>
          <p>1080x1920</p>
        </div>

        <div>
          <PreviewWrapper
            onClick={() => {
              setActiveKey("2");
              setOpen(true);
            }}
          >
            <HorizontalRectangleShape
              logoSrc={logoSrc}
              callText={texts.callText}
              imageUrl={confirmedImage}
              primaryText={texts.primaryText}
              secondaryText={texts.secondaryText}
              shape={layout.layout}
              variantColor={layout.color}
              x_axis={x_axis.hr}
              size={biggerPreview ? 896 : HRModalScale}
              positions={{
                imagePosition: convertPositionRatio({
                  currentSize: biggerPreview ? 896 : HRModalScale,
                  draggableSize: HRModalScale,
                  positions: positionsHR[0],
                }),
                logoPosition: convertPositionRatio({
                  currentSize: biggerPreview ? 896 : HRModalScale,
                  draggableSize: HRModalScale,
                  positions: positionsHR[1],
                }),
                labelsPosition: convertPositionRatio({
                  currentSize: biggerPreview ? 896 : HRModalScale,
                  draggableSize: HRModalScale,
                  positions: positionsHR[2],
                }),
              }}
            />
          </PreviewWrapper>
          <p>1200x628</p>
        </div>
      </LayoutsPreviewContainer>

      <RepositionElementsModal
        open={open}
        setOpen={setOpen}
        layout={layout}
        imageSrc={confirmedImage}
        logoSrc={logoSrc}
        texts={texts}
        squarePositions={positions}
        setSquarePositions={setPositions}
        squareModalScale={squareModalScale}
        resetSquare={resetSquare}
        HRModalScale={HRModalScale}
        positionsHR={positionsHR}
        setPositionsHR={setPositionsHR}
        VRModalScale={VRModalScale}
        positionsVR={positionsVR}
        setPositionsVR={setPositionsVR}
        resetHR={resetHR}
        resetVR={resetVR}
        defaultActiveKey={activeKey}
        setActiveKey={setActiveKey}
        changeAxis={changeAxis}
        x_axis={x_axis}
      />
    </Wrapper>
  );
}

function RepositionElementsModal({
  open,
  setOpen,
  layout,
  imageSrc,
  logoSrc,
  texts,
  squarePositions,
  setSquarePositions,
  squareModalScale,
  resetSquare,
  defaultActiveKey = "1",
  positionsHR,
  setPositionsHR,
  HRModalScale,
  resetHR,
  positionsVR,
  setPositionsVR,
  VRModalScale,
  resetVR,
  setActiveKey,
  changeAxis,
  x_axis,
}) {
  const [isSquareImage, setIsSquareImage] = useState(false);

  useEffect(() => {
    if (!imageSrc) {
      setIsSquareImage(false);
      return;
    }

    const img = new Image();
    img.src = imageSrc;

    img.onload = () => {
      const ratio = img.width / img.height;
      setIsSquareImage(Math.abs(ratio - 1) < 0.001);
    };

    img.onerror = () => {
      setIsSquareImage(false);
    };
  }, [imageSrc]);

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      closable={false}
      footer={""}
      width={"fit-content"}
      centered
    >
      <Tabs
        activeKey={defaultActiveKey}
        centered
        onChange={(a) => setActiveKey(a)}
      >
        <Tabs.TabPane tab="1080 x 1350" key="1">
          {!isSquareImage && (
            <Slider
              defaultValue={x_axis.square}
              onChange={(e) => {
                changeAxis({
                  layout: "square",
                  value: e,
                });
              }}
              tooltip={{ formatter: (value) => `${value}%` }}
            />
          )}
          <FlexContainer direction={"row"} gap={"12px"} center>
            <Limiter>
              <DraggableSquare
                logoSrc={logoSrc}
                size={squareModalScale}
                positions={squarePositions}
                setPositions={setSquarePositions}
                squareSizes={pickSquareDefaultSizes({
                  shape: layout.layout,
                  size: squareModalScale,
                })}
                variantColor={layout.color}
                selectedImage={imageSrc}
                texts={texts}
                x_axis={x_axis.square}
              />
            </Limiter>

            <Limiter>
              <SquareShape
                logoSrc={logoSrc}
                callText={texts.callText}
                imageUrl={imageSrc}
                primaryText={texts.primaryText}
                secondaryText={texts.secondaryText}
                shape={layout.layout}
                variantColor={layout.color}
                size={squareModalScale}
                x_axis={x_axis.square}
                positions={{
                  imagePosition: convertPositionRatio({
                    currentSize: squareModalScale,
                    draggableSize: squareModalScale,
                    positions: squarePositions[0],
                  }),
                  logoPosition: convertPositionRatio({
                    currentSize: squareModalScale,
                    draggableSize: squareModalScale,
                    positions: squarePositions[1],
                  }),
                  labelsPosition: convertPositionRatio({
                    currentSize: squareModalScale,
                    draggableSize: squareModalScale,
                    positions: squarePositions[2],
                  }),
                }}
              />
            </Limiter>
          </FlexContainer>

          <FlexContainer direction={"row"} gap={"24px"} marginTop="16px">
            <Button
              size={"modal"}
              theme={"secondary"}
              onClick={resetSquare}
              label={"ai_cretor.reset-1080x1350"}
            />
            <Button
              onClick={() => setOpen(false)}
              size={"modal"}
              label={"confirm"}
            />
          </FlexContainer>
        </Tabs.TabPane>

        <Tabs.TabPane tab="1200 x 628" key="2">
          {!isSquareImage && (
            <Slider
              defaultValue={x_axis.hr}
              onChange={(e) => {
                changeAxis({
                  layout: "hr",
                  value: e,
                });
              }}
              tooltip={{ formatter: (value) => `${value}%` }}
            />
          )}
          <FlexContainer direction={"column"} gap={"12px"} center>
            <Limiter>
              <DraggableHorizontalRectangle
                size={HRModalScale}
                logoSrc={logoSrc}
                positions={positionsHR}
                setPositions={setPositionsHR}
                horizontalRectangleSizes={pickHorizontalRectangleDefaultSizes({
                  shape: layout.layout,
                  size: HRModalScale,
                })}
                variantColor={layout.color}
                selectedImage={imageSrc}
                texts={texts}
                x_axis={x_axis.hr}
              />
            </Limiter>

            <Limiter>
              <HorizontalRectangleShape
                logoSrc={logoSrc}
                callText={texts.callText}
                imageUrl={imageSrc}
                primaryText={texts.primaryText}
                secondaryText={texts.secondaryText}
                shape={layout.layout}
                variantColor={layout.color}
                x_axis={x_axis.hr}
                size={HRModalScale}
                positions={{
                  imagePosition: convertPositionRatio({
                    currentSize: HRModalScale,
                    draggableSize: HRModalScale,
                    positions: positionsHR[0],
                  }),
                  logoPosition: convertPositionRatio({
                    currentSize: HRModalScale,
                    draggableSize: HRModalScale,
                    positions: positionsHR[1],
                  }),
                  labelsPosition: convertPositionRatio({
                    currentSize: HRModalScale,
                    draggableSize: HRModalScale,
                    positions: positionsHR[2],
                  }),
                }}
              />
            </Limiter>
          </FlexContainer>

          <FlexContainer direction={"row"} gap={"24px"} marginTop="16px">
            <Button
              size={"modal"}
              theme={"secondary"}
              onClick={resetHR}
              label={"ai_cretor.reset-1200x628"}
            />
            <Button
              onClick={() => setOpen(false)}
              size={"modal"}
              label={"confirm"}
            />
          </FlexContainer>
        </Tabs.TabPane>

        <Tabs.TabPane tab="1080 x 1920" key="3">
          {!isSquareImage && (
            <Slider
              defaultValue={x_axis.vr}
              onChange={(e) => {
                changeAxis({
                  layout: "vr",
                  value: e,
                });
              }}
              tooltip={{ formatter: (value) => `${value}%` }}
            />
          )}
          <FlexContainer direction={"row"} gap={"12px"} center>
            <Limiter>
              <DraggableVerticalRectangle
                size={VRModalScale}
                logoSrc={logoSrc}
                positions={positionsVR}
                setPositions={setPositionsVR}
                verticalRectangleSizes={pickVerticalRectangleDefaultSizes({
                  shape: layout.layout,
                  size: VRModalScale,
                })}
                variantColor={layout.color}
                selectedImage={imageSrc}
                texts={texts}
                x_axis={x_axis.vr}
              />
            </Limiter>

            <Limiter>
              <VerticalRectangleShape
                logoSrc={logoSrc}
                callText={texts.callText}
                imageUrl={imageSrc}
                primaryText={texts.primaryText}
                secondaryText={texts.secondaryText}
                shape={layout.layout}
                variantColor={layout.color}
                size={VRModalScale}
                x_axis={x_axis.vr}
                positions={{
                  imagePosition: convertPositionRatio({
                    currentSize: VRModalScale,
                    draggableSize: VRModalScale,
                    positions: positionsVR[0],
                  }),
                  logoPosition: convertPositionRatio({
                    currentSize: VRModalScale,
                    draggableSize: VRModalScale,
                    positions: positionsVR[1],
                  }),
                  labelsPosition: convertPositionRatio({
                    currentSize: VRModalScale,
                    draggableSize: VRModalScale,
                    positions: positionsVR[2],
                  }),
                }}
              />
            </Limiter>
          </FlexContainer>

          <FlexContainer direction={"row"} gap={"24px"} marginTop="16px">
            <Button
              size={"modal"}
              theme={"secondary"}
              onClick={resetVR}
              label={"ai_cretor.reset-1080x1920"}
            />
            <Button
              onClick={() => setOpen(false)}
              size={"modal"}
              label={"confirm"}
            />
          </FlexContainer>
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
}
